import infoData from './InfoData';

export const InfoData = infoData;

export default InfoData;
